import axios from 'axios'
import {useEffect, useState} from 'react'

const useDeepCorrelation = (financialInfo, privateCompany, ticker, openModal, timeFrame, selectedDatasetDict) => {
    const [loading, setLoading] = useState(false) 
    const [correlationData, setCorrelationData] = useState([]) 

    useEffect ( () => {
        if (openModal && timeFrame && financialInfo && selectedDatasetDict) {
          setLoading(true)
          // fetch('/api/getLaggedCorrelationGraph', {
          //   method: 'POST',
          //   headers: {'Content-Type': 'application/json'},
          //   body: JSON.stringify({
          //       ticker,
          //       private: privateCompany,
          //       financialInfo: financialInfo,
          //       dataset: [selectedDatasetDict.datasetValue],
          //       column:  [selectedDatasetDict.columnValue],
          //       lag_date_type: timeFrame,
          //       agg_type: selectedDatasetDict.agg,
          //     })   
          //   })
            axios({
              method: 'post',
              url: '/api/getLaggedCorrelationGraph',
              data: {
                        ticker,
                        private: privateCompany,
                        financialInfo: financialInfo,
                        dataset: [selectedDatasetDict.datasetValue],
                        column:  [selectedDatasetDict.columnValue],
                        lag_date_type: timeFrame,
                        agg_type: selectedDatasetDict.agg,
                    }

            })
            .then(res => res.data)
            .then(res => {
              let data = res.length>0?res.map(item=> {return {'index':item.index,'value':item.value*100}}):res
              setCorrelationData(data)
            })
            .finally(() => setLoading(false))
        }
      },[openModal,timeFrame,financialInfo,selectedDatasetDict]) // eslint-disable-line

      return { 
        loading,
        correlationData
      }
}

export default useDeepCorrelation